import { Box, Card, CardMedia, colors, Container, Grid, LinearProgress, TextField, Typography } from '@mui/material'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { formatValor } from '../../services/utils.js'
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom'
import { verificarPagamentoAction } from '../../store/reducers/utils'
import logo from '../../images/0819db8c82d9cffc3dd22bd091848a1f.png'
import LoadingPix from './LoadingPix.jsx'
import SnackbarPick from '../../components/SnackbarPick/SnackbarPick.jsx'
import ButtonPick from '../../components/ButtonPick/ButtonPick.jsx'

const useTimer = (initialTime, setPorcentagemTempo) => {
    const [segundos, setSegundos] = useState(initialTime);
    const interval = useRef(null);
    useEffect(() => {
        interval.current = setInterval(() => {
            setSegundos((prevSegundos) => {
                const novoSegundos = prevSegundos - 1;
                if (novoSegundos > 0) {
                    setPorcentagemTempo((novoSegundos * 100) / initialTime);
                } else {
                    clearInterval(interval.current);
                    setPorcentagemTempo(0);
                }
                return novoSegundos;
            });
        }, 1000);
        return () => clearInterval(interval.current);
    }, [initialTime, setPorcentagemTempo]);
    return segundos;
};

const CheckoutPix = () => {
    //Hooks e variáveis
    const ID_GATEWAY_PIX = 'be246a0c-b9f0-11ec-8725-1c1bb54b8682'
    const ID_GATEWAY = '8a04d1a6-128a-11ed-ab9c-12d2147dce0f'
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const dadosCompra = useSelector(state => state.utils.respostaEnviar);
    const dadosTroca = useSelector(state => state.plano.respostaTroca);
    const planoEscolhido = useSelector(state => state.utils.planoEscolhido);
    const situacaoPagamento = useSelector(state => state.utils.situacaoPagamento);
    const [codigoPix, setCodigoPix] = useState('');
    const [qrCode, setQrCode] = useState('');
    const [copyAlert, setCopyAlert] = useState(false);
    const [porcentagemTempo, setPorcentagemTempo] = useState(100);
    const [alertError, setAlertError] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [prosseguir, setProsseguir] = useState(false)
    const intervalPix = useRef(null);
    const segundos = useTimer(600, setPorcentagemTempo); // 10 minutos
    const opcaoSelecionada1 = useSelector(state => state.plano.opcaoSelecionada);


    const [formaPagamentoAtual, setFormaPagamentoAtual] = useState(() => {
        if (opcaoSelecionada1?.formasPagamento?.[0]?.formaPagamentoID === ID_GATEWAY ||
            opcaoSelecionada1?.formasPagamento?.[0]?.formaPagamentoID === ID_GATEWAY_PIX) {
            return opcaoSelecionada1?.formasPagamento?.[0];
        } else {
            return { id: 0, nome: '', numeroParcelas: 0, valorFinal: 0 };
        }
    });
    const cupomInfo = useSelector(state => state.utils.cupomInfo);
    const [dadosPagamento, setDadosPagamento] = useState(formaPagamentoAtual);


    useEffect(() => {
        if (cupomInfo?.data?.valorFinal) {
            setDadosPagamento({
                ...formaPagamentoAtual,
                valorFinal: cupomInfo.data.valorFinal,
                valorOriginal: cupomInfo.data.valor,
                desconto: cupomInfo.data.desconto,
            });
        } else {
            setDadosPagamento(formaPagamentoAtual);
        }
    }, [cupomInfo, formaPagamentoAtual]);

    useEffect(() => {
        if (dadosCompra.assinaturaCriadaID || dadosTroca?.assinaturaCriadaID) {
            intervalPix.current = setInterval(() => {
                dispatch(verificarPagamentoAction(dadosCompra ? dadosCompra.assinaturaCriadaID : dadosTroca.assinaturaCriadaID));
            }, 10000);
        }
        return () => clearInterval(intervalPix.current);
    }, []);

    useEffect(() => {
        if (dadosCompra?.sucesso || dadosTroca?.sucesso) {
            if (dadosCompra?.modelo) {
                const { pixQrcode, pixQrCodeBase64 } = dadosCompra.modelo;
                setCodigoPix(pixQrcode);
                setQrCode(pixQrCodeBase64);
            } else if (dadosTroca?.qrCode) {
                setCodigoPix(dadosTroca.copiaCola);
                setQrCode(dadosTroca.qrCode);
            }
            else {
                setCodigoPix(dadosCompra?.copiaCola || dadosTroca?.copiaCola)
                setQrCode(dadosCompra?.qrCode || dadosTroca?.qrCode)
            }
        }
    }, [dadosCompra?.sucesso, dadosTroca?.sucesso]);

    const conferirPagamento = useCallback(() => {
        if (situacaoPagamento && Object.keys(situacaoPagamento)?.length > 0) {
            const { sucesso, mensagem, inadimplente } = situacaoPagamento;

            if (!sucesso) {
                setAlertError(true);
                setAlertMessage(mensagem);
            }
            if (sucesso && !inadimplente) {
                setProsseguir(true);
            }
        }
    }, [situacaoPagamento]);

    const handleConferirPagamento = useCallback(() => {
        const conferirPagamento = async () => {
            const { sucesso, mensagem, inadimplente } = situacaoPagamento
            if (sucesso) {
                if (inadimplente || dadosTroca?.pagamentoOk) {
                    setAlertError(true)
                    setAlertMessage(mensagem)
                } else {
                    setProsseguir(true)
                }
            }
        }
        //const id = dadosCompra.modelo === undefined ? dadosCompra.assinaturaID : dadosCompra.modelo.assinaturaID
        let id = dadosCompra.modelo === undefined ? dadosCompra.assinaturaID : dadosCompra.modelo.assinaturaID
        id = dadosCompra.assinaturaCriadaID !== undefined ? dadosCompra.assinaturaCriadaID : id
        dispatch(verificarPagamentoAction(id || dadosTroca?.assinaturaID));

        conferirPagamento()
    }, [dadosCompra.assinaturaCriadaID, situacaoPagamento, dispatch]);

    useEffect(() => {
        conferirPagamento()
    }, [situacaoPagamento])

    useEffect(() => {
        if (prosseguir) {
            navigate('/finalizar')
        }
    }, [prosseguir, navigate]);

    const handleCopyToClipboard = () => {
        navigator.clipboard.writeText(codigoPix);
        setCopyAlert(true);
    };

    // Estilizações de componentes
    const textFieldStyles = {
        '& label.Mui-focused': {
            color: '#FF9F0D',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#FF9F0D',
            },
            '&:hover fieldset': {
                borderColor: '#FF9F0D',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#FF9F0D',
            },
        },
    };

    const typographyStyles = {
        fontSize: '1rem',
        fontWeight: '500',
        color: '#000000',
        textAlign: 'center',
    }

    const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
        height: 10,
        borderRadius: 5,
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
        '& .MuiLinearProgress-bar': {
            borderRadius: 5,
            backgroundColor: '#FF9F0D', // Cor ajustada conforme especificado
        },
    }));

    return (
        <Container maxWidth="sm">
            <Grid container spacing={2} alignItems="center" justifyContent="center" mt={2}>
                <Grid item xs={3} >
                    <Card sx={{ boxShadow: 'none' }}>
                        <CardMedia component="img" image={logo} alt='Logo' />
                    </Card>
                </Grid>
                <Grid item xs={12} sx={{ '&.MuiGrid-item': { p: '0' } }} /> {/* Espaçamento */}
                <Grid item xs={8}>
                    <Card
                        elevation={3}
                        sx={{ borderRadius: '40px', p: 1, boxSizing: 'border-box', }}
                    >
                        {qrCode ? (
                            <CardMedia
                                component="img"
                                src={`data:image/png;base64,${qrCode}`}
                                alt='QR Code'
                                sx={{
                                    width: '100%',
                                    height: 'auto',
                                }}
                            />
                        ) :
                            <Box
                                sx={{
                                    display: "grid",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: '100%',
                                    aspectRatio: '1 / 1'
                                }}
                            >
                                <LoadingPix />
                            </Box>}
                    </Card>
                </Grid>
                <Grid item xs={12}>
                    <Typography sx={typographyStyles}>Falta pouco! Escaneie o QR Code com seu app de pagamento ou Internet Banking.</Typography>
                    <Typography sx={typographyStyles}>
                        Valor do pagamento:
                        <span
                            style={{
                                color: '#FF9F0D',
                                fontWeight: '700',
                                fontSize: '1.2rem',
                                marginLeft: '5px',
                            }}
                        >
                            {formatValor(dadosPagamento?.valorFinal)}
                        </span>
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography sx={typographyStyles}>
                        Tempo restante para o pagamento: {Math.floor(segundos / 60)}:{segundos % 60 < 10 ? `0${segundos % 60}` : segundos % 60}
                    </Typography>
                    <BorderLinearProgress
                        variant="determinate"
                        value={porcentagemTempo}
                        sx={{ height: '10px', borderRadius: '5px' }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label="Pix Copia e Cola"
                        variant="outlined"
                        fullWidth
                        multiline
                        minRows={4}
                        InputProps={{ readOnly: true }}
                        sx={textFieldStyles}
                        value={codigoPix}
                    />
                </Grid>
                <Grid item xs={10} justifyContent={'center'} >
                    <ButtonPick
                        text={'Copiar Pix Copia e Cola'}
                        onClick={handleCopyToClipboard}
                    />
                </Grid>
                <Grid item xs={10}>
                    <ButtonPick
                        text={'Conferir Pagamento'}
                        onClick={handleConferirPagamento}
                        addStyle={{ backgroundColor: '#000000', '&:hover': { backgroundColor: '#222' }, color: '#fff' }}
                    />
                </Grid>
            </Grid>
            <SnackbarPick
                type={'success'}
                message="Copiado para a área de transferência!"
                open={copyAlert}
                setOpen={setCopyAlert}
                duration={5000}
            />
            <SnackbarPick
                type={'error'}
                message={alertMessage}
                open={alertError}
                setOpen={setAlertError}
            />
        </Container>
    )
}

export default CheckoutPix
